<template>
  <v-container>
    <v-row class-name="pb-0">
      <v-col v-if="showedExpireAlert" cols="12" class-name="py-0">
        <v-container fluid class-name="py-0">
          <expire-plan-alert @closed="showedExpireAlert = false" />
        </v-container>
      </v-col>

      <v-col v-if="!isSmartManualsPlansActive" cols="12" class="px-9">
        <v-tabs v-model="selectedMode" height="54">
          <v-tab v-for="tab in availableTabs" :key="tab.value" class="text-none">
            <feather :type="tab.icon" class="mr-3" />

            {{ tab.title }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <component :is="currentStatsComponent" />
  </v-container>
</template>

<script>
  import moment from 'moment';
  import { mapGetters, mapState } from 'vuex';

  import localStorage from 'src/services/localStorage';

  import ScenariosStats from 'src/pages/Dashboard/components/ScenariosStats.vue';
  import SimulationsStats from 'src/pages/Dashboard/components/SimulationsStats.vue';
  import TooltipsStats from 'src/pages/Dashboard/components/TooltipsStats.vue';
  import HelpCenterStats from 'src/pages/Dashboard/components/HelpCenterStats.vue';
  import ExpirePlanAlert from 'src/components/ExpirePlanAlert/ExpirePlanAlert.vue';

  export default {
    name: 'Dashboard',

    components: {
      ScenariosStats,
      SimulationsStats,
      ExpirePlanAlert,
      HelpCenterStats,
      TooltipsStats,
    },

    data() {
      return {
        mode: localStorage.get('dashboardMode') || 0,
        showedExpireAlert: false,
      };
    },

    computed: {
      ...mapState('users', ['currentUser']),
      ...mapGetters('users', ['isSmartManualsPlansActive', 'isSimulationAccessPlansActive']),

      availableTabs() {
        return [
          {
            value: 0,
            title: this.$t('pages.statistics.scenariosStats'),
            icon: 'message-square',
            component: ScenariosStats,
          },
          {
            value: 1,
            title: this.$t('pages.statistics.tooltipsStats'),
            icon: 'message-circle',
            component: TooltipsStats,
          },
          ...(this.isSimulationAccessPlansActive
            ? [
                {
                  value: 2,
                  title: this.$t('pages.statistics.simulationsStats'),
                  icon: 'package',
                  component: SimulationsStats,
                },
              ]
            : []),
          {
            value: 3,
            title: this.$t('pages.statistics.helpCenterStatistics'),
            icon: 'alert-circle',
            component: HelpCenterStats,
          },
        ];
      },

      selectedMode: {
        get() {
          const index = this.availableTabs.findIndex(tab => tab.value === this.mode);
          return index !== -1 ? index : 0;
        },

        set(value) {
          const tab = this.availableTabs[value];
          if (tab) {
            localStorage.set('dashboardMode', tab.value);
            this.mode = tab.value;
          }
        },
      },

      currentStatsComponent() {
        if (this.isSmartManualsPlansActive) {
          return SimulationsStats;
        }

        const currentTab = this.availableTabs.find(tab => tab.value === this.mode);
        return currentTab ? currentTab.component : ScenariosStats;
      },
    },

    async mounted() {
      if (!this.isSmartManualsPlansActive) {
        this.showExpiredAlert();
      }
    },

    methods: {
      showExpiredAlert() {
        const expireAlertClosingStatuses = localStorage.get('expireAlertClosingStatuses') || {};

        const activeUntilDate = moment.utc(this.currentUser.organizationActiveUntil);

        if (
          activeUntilDate.diff(moment.utc(), 'days', true) <= 30 &&
          activeUntilDate.diff(moment.utc(), 'days', true) > 20 &&
          !expireAlertClosingStatuses?.[30]
        ) {
          this.showedExpireAlert = true;

          return;
        }

        if (
          activeUntilDate.diff(moment.utc(), 'days', true) <= 20 &&
          activeUntilDate.diff(moment.utc(), 'days', true) > 10 &&
          !expireAlertClosingStatuses?.[20]
        ) {
          this.showedExpireAlert = true;

          return;
        }

        if (
          activeUntilDate.diff(moment.utc(), 'days', true) <= 10 &&
          activeUntilDate.diff(moment.utc(), 'days', true) > 7 &&
          !expireAlertClosingStatuses?.[20]
        ) {
          this.showedExpireAlert = true;

          return;
        }

        [7, 6, 5, 4, 3, 2, 1].forEach(daysLeft => {
          if (
            activeUntilDate.diff(moment.utc(), 'days', true) <= daysLeft &&
            activeUntilDate.diff(moment.utc(), 'days', true) > daysLeft - 1 &&
            !expireAlertClosingStatuses?.[daysLeft]
          ) {
            this.showedExpireAlert = true;
          }
        });
      },
    },
  };
</script>

<style lang="scss"></style>
